import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]
  static values = {
    url: String
  }

  handleClick(event) {
    event.preventDefault()

    // Prompt user to type "CONFIRM"
    const confirmation = prompt('WARNING: This will force the tax organizer to "submitted" status regardless of completion. This is intended for abandoned or special support cases.\n\nTo proceed, please type "CONFIRM" (all caps):')

    if (confirmation === "CONFIRM") {
      // User confirmed, proceed with force submit
      this.forceSubmit()
    }
  }

  async forceSubmit() {
    const button = this.buttonTarget
    const originalHTML = button.innerHTML

    button.disabled = true
    button.innerHTML = '<i class="fas fa-spinner fa-spin me-2"></i>Submitting...'

    try {
      const response = await fetch(this.urlValue, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        }
      })

      const data = await response.json()

      if (response.ok && data.success) {
        // Show success message
        alert(data.message)

        // Reload to show updated status
        location.reload()
      } else {
        // Show error message
        alert(`Error: ${data.message || 'Failed to force submit tax organizer'}`)

        // Re-enable button
        button.disabled = false
        button.innerHTML = originalHTML
      }
    } catch (error) {
      console.error('Error force submitting tax organizer:', error)
      alert('An error occurred while force submitting the tax organizer')

      // Re-enable button
      button.disabled = false
      button.innerHTML = originalHTML
    }
  }
}
